<!DOCTYPE html>
<div class="content-wrapper">
  <div class="shareButton-wrapper">
    <div class="twitter">
      <share-button [theme]="'default'" [button]="'twitter'" [url]="shareLink" [description]="referralMessage"></share-button>
      <span>Twitter</span>
    </div>
    <div class="facebook">
      <share-button [theme]="'default'" [button]="'facebook'" [url]="shareLink" [description]="referralMessage" [autoSetMeta]="false"> </share-button>
      <span>Facebook</span>
    </div>
  </div>
</div>
